// Client side of the PWA Share Target flow. The service worker stashes
// shared image(s) in a cache (see service-worker.ts); this reads and clears
// them so the app can attach them to the assistant.

const SHARED_CACHE = 'tripsplit-shared';

export async function takeSharedFiles(): Promise<File[]> {
  if (typeof caches === 'undefined') return [];
  try {
    const cache = await caches.open(SHARED_CACHE);
    const countRes = await cache.match('/__shared_count');
    if (!countRes) return [];
    const count = parseInt(await countRes.text(), 10) || 0;
    const files: File[] = [];
    for (let i = 0; i < count; i += 1) {
      const res = await cache.match(`/__shared_${i}`);
      if (res) {
        const blob = await res.blob();
        const ext = (blob.type.split('/')[1] || 'png').replace('jpeg', 'jpg');
        files.push(new File([blob], `shared-receipt-${i + 1}.${ext}`, { type: blob.type }));
      }
    }
    // Clear so we don't re-attach on the next mount.
    await cache.delete('/__shared_count');
    for (let i = 0; i < count; i += 1) await cache.delete(`/__shared_${i}`);
    return files;
  } catch {
    return [];
  }
}
